import React, { useEffect, useState } from 'react'
import ImageViewer from '../../../../../common/components/organisme/ImageViewer/ImageViewer'


import { getStationThumbnailSrc } from '../../../services/stationsAPI'

import useSingleStation from '../../../hooks/useSingleStation'
import AddThumbnailBtnModal from '../../AddThumbnailBtnModal/AddThumbnailBtnModal'
import FileListManager, { FileUrl } from '../../../../../common/components/molecule/FileListManager/FileListManager'
import Button from '../../../../../common/components/atom/Button/Button'

export default function SingleStationImagePresenter({style}:{    style?:  React.CSSProperties | undefined}) {
    const {stationId, singleStationQuery} = useSingleStation()
    const [src, setSrc] = useState<string | undefined>(undefined)

    const [isChanging, setIsChanging] = useState(false)
    

    const handleIsChanging = (isChanging : boolean) => {
        setIsChanging(isChanging)
    }
    useEffect(() => {
      const srcRaw =  stationId ? getStationThumbnailSrc(stationId) : undefined;
      setSrc(srcRaw)

    },[isChanging, stationId])

    return (
    <>
    {
      !isChanging ?
      <ImageViewer src={(singleStationQuery?.data?.station_thumbnail_image_file_id && singleStationQuery?.data?.station_thumbnail_image_file_id !== "" ) ? src : undefined} style={style} WidgetTop={() => <AddThumbnailBtnModal  contentRender={({closeModal}) => <><AddThumbnailForm closeModal={closeModal} setIsChanging={handleIsChanging}/></>}/>} />
      :
      <ImageViewer style={style}  />
    }
    </>
  )
}

export const AddThumbnailForm = ({closeModal, setIsChanging}:{closeModal?: () => void, setIsChanging?: (isChanging : boolean) => void}) => {

  const [listFiles, setFileList] = useState<FileUrl[]>([])
  const {addThumbnailStationQuery} = useSingleStation()

  const handleAddFiles = () => {
         setIsChanging && setIsChanging(true)
    addThumbnailStationQuery.mutate({
      fileUrl: listFiles[0],
      callback: ({result, error}) => {
   
        if (error) {
          console.error("Error while adding thumbnail", error)
          setIsChanging && setIsChanging(false)
        } else {
          console.log("Thumbnail added successfully", result)
          setIsChanging && setIsChanging(false)
          closeModal && closeModal()
        
        }
      }
    })
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 20}}>
      <FileListManager 
        listFiles={listFiles}
        setFileList={setFileList}
        messageEmpty="Aucun fichier"
        limitFiles={1}
        addLabel="Ajouter une image"
        noAddFile={false}
        label="Image de la station"
        accept="image/*"
        isError={false}
   
        />
       
        <Button onClick={handleAddFiles} variant="primary" isLoading={addThumbnailStationQuery.isLoading} disabled={listFiles.length <= 0}>Modifier</Button>
        </div>
 
  )
}